import { Icon } from '@/components/foundations';

/**
 * Ícone ⓘ com dica (`title` nativo do SVG + nome acessível).
 * Sem `content`, é só o ícone decorativo do pacote.
 */
export function InfoHint({ content }: { content?: string }) {
  return <Icon name="info" title={content} />;
}
